
import { useState } from 'react'
import './style.scss'
// import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import { DashboardSubPages } from '../../types/types'
import { PAGE_URLS } from '../../constants/hrefLinks'

function AdminSideMenu() {
	const [menuCollapsed, setMenuCollapsed] = useState<boolean>(false)

	const subPage: string = useAppSelector(state => state.dashboard.subPage)

	return (
		<div className={menuCollapsed ? 'dashboard-instructor-side-menu-wrap dashboard-side-menu-wrap-collapsed' : 'dashboard-instructor-side-menu-wrap'}>
			<div className='dashboard-side-menu-logo-wrap'>
				<a
					className='dashboard-side-menu-logo'
					href={PAGE_URLS.ADMIN}
				>
					<img
						className='dashboard-side-menu-logo-img'
						src={menuCollapsed ? '/imgs/logos/logo-small-over-white.svg' : '/imgs/logos/logo-text.svg'}
						alt='logo'
					/>
				</a>
				<img
					className={menuCollapsed ? 'dashboard-instructor-side-menu-collapse-button dashboard-instructor-side-menu-collapse-button-collapsed' : 'dashboard-instructor-side-menu-collapse-button'}
					src={`/imgs/icons/dashboard/icon-dashboard-collapse.svg`}
					alt='Collapse Button'
					onClick={() => setMenuCollapsed(!menuCollapsed)}
				/>
			</div>
			<div className='dashboard-side-menu-button-wrap'>
				<button
					className={subPage === DashboardSubPages.CUSTOMERS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
					onClick={() => { window.location.replace(PAGE_URLS.ADMIN_ALL_CUSTOMERS) }}
				>
					<img
						className='dashboard-instructor-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-customers.svg`}
						alt='See Chat Button'
					/>
					{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Customers</div>}
				</button>
				<button
					className={subPage === DashboardSubPages.INSTRUCTORS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
					onClick={() => { window.location.replace(PAGE_URLS.ADMIN_ALL_INSTRUCTOR) }}
				>
					<img
						className='dashboard-instructor-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-instructors.svg`}
						alt='Reviews Button'
					/>
					{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Instructors</div>}
				</button>
				<button
					className={subPage === DashboardSubPages.CHATS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
					onClick={() => { window.location.replace(PAGE_URLS.ADMIN_CHATS) }}
				>
					<img
						className='dashboard-instructor-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-chat.svg`}
						alt='See Chat Button'
					/>
					{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Chats</div>}
				</button>
				<button
					className={subPage === DashboardSubPages.SUPPORT ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
					onClick={() => { window.location.replace(PAGE_URLS.ADMIN_ALL_INSTRUCTOR) }}
				>
					<img
						className='dashboard-instructor-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-support.svg`}
						alt='See Chat Button'
					/>
					{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Support</div>}
				</button>
				<div
					className='dashboard-admin-side-menu-bottom-button-wrap'
				>
					{/* <button
						className={subPage === DashboardSubPages.SETTINGS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
						onClick={() => console.log('settings clicked')}
					>
						<img
							className='dashboard-instructor-side-menu-button-icon dashboard-side-menu-button-icon-white'
							src={`/imgs/icons/dashboard/icon-dashboard-settings-white.svg`}
							alt='Settings Button'
						/>
						{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Settings</div>}
					</button> */}
					<button
						className='dashboard-instructor-side-menu-button'
						onClick={() => window.location.replace(PAGE_URLS.ADMIN)}
					>
						<img
							className='dashboard-instructor-side-menu-button-icon dashboard-instructor-side-menu-button-icon-white'
							src={`/imgs/icons/dashboard/icon-dashboard-home.svg`}
							alt='Home Button'
						/>
						{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Home</div>}
					</button>
				</div>
			</div>
		</div>
	)
}

export default AdminSideMenu
